// extracted by mini-css-extract-plugin
export default {"warningBg":"Warning_warningBg__MvZSO","warningContainer":"Warning_warningContainer__p84jj","warning":"Warning_warning__c-OOz","warningContent":"Warning_warningContent__-0Mak"};